import React, { useState } from 'react';
import './Add_Notification.css';  
import config from '../../config';  
import SuccessModal from '../modelpopup'; // Import the SuccessModal component

const AddNotification = () => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState(null);
    const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false); // Success modal state

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        const notificationData = { title, description };

        try {
            const response = await fetch(`${config.backendUrl}/api/add_notification`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(notificationData),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to add notification');
            }

            await response.json();
            setIsSuccessModalVisible(true);

            setTimeout(() => {
                setIsSuccessModalVisible(false); 
            }, 3000);

            setTitle('');
            setDescription('');
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <div className="formContainer">
            <h2 className="header">Add Notification</h2>
            <form onSubmit={handleSubmit}>
                <div className="formGroup">
                    <label htmlFor="title" className="label">Title</label>
                    <input
                        type="text"
                        id="title"
                        placeholder="Enter notification title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                        className="input"
                    />
                </div>

                <div className="formGroup">
                    <label htmlFor="description" className="label">Description</label>
                    <textarea
                        id="description"
                        placeholder="Enter notification description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                        className="textarea"
                    ></textarea>
                </div>

                <button type="submit" className="submitBtn">Add Notification</button>
            </form>

            {error && <p className="errorMessage">{error}</p>}

            {/* Success Modal */}
            {isSuccessModalVisible && (
                <SuccessModal message="Notification added successfully!" onClose={() => setIsSuccessModalVisible(false)} />
            )}
        </div>
    );
};

export default AddNotification;
